/* eslint-disable react/prop-types */
import React from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import * as S from './CatalogGoodImageBlock.styled'
import { ColorConsts } from '@styles/theme-const'
import { errorImage, getUslImage } from '@services/catalogService'

const CatalogGoodImageBlock = (props) => {
    const imageUrl = getUslImage(props.hasImage, props.id)

    return (
        <Link href={props.linkGoodCart} passHref legacyBehavior>
            <S.Container>
                <S.ImageContainer>
                    <S.Image
                        src={imageUrl}
                        loading={'lazy'}
                        onError={(e) => {
                            e.target.onerror = null
                            e.target.src = errorImage
                        }}
                    />
                </S.ImageContainer>
                <S.ParamtersBlock>
                    {props.isCold && <S.ParameterItem color={ColorConsts.colorCold}>Хранение в холоде</S.ParameterItem>}
                    {props.isStrictlyByPrescription && (
                        <S.ParameterItem color={ColorConsts.getRedheadColor(1)}>Строго по рецепту</S.ParameterItem>
                    )}
                    {!props.deliveryStatus?.isAvailableForDelivery && props.isAvailableDeliveryByErecipe ? (
                        <S.ParameterItem color={ColorConsts.getBlue60Color()}>Доставка по рецепту</S.ParameterItem>
                    ) : (
                        <React.Fragment />
                    )}
                </S.ParamtersBlock>
            </S.Container>
        </Link>
    )
}

CatalogGoodImageBlock.propTypes = {
    id: PropTypes.number.isRequired,
    hasImage: PropTypes.bool.isRequired,
    linkGoodCart: PropTypes.string,
    isCold: PropTypes.bool,
    isStrictlyByPrescription: PropTypes.bool,
    isAvailableDeliveryByErecipe: PropTypes.bool,
    deliveryStatus: PropTypes.shape({
        isAvailableForDelivery: PropTypes.bool.isRequired,
        reasons: PropTypes.arrayOf(
            PropTypes.shape({
                deliveryReasonID: PropTypes.number.isRequired,
                warningText: PropTypes.string
            })
        )
    })
}

export default CatalogGoodImageBlock
